import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useToast } from "@repo/ui";
import { configurationApi } from "~/api";
import { getErrorMessage } from "~/hooks/helpers";

export const useRenameWorkflow = () => {
  const { showToast } = useToast();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ workflowId, name }: { workflowId: number; name: string }) => {
      const response = await configurationApi.client.PATCH("/api/Workflow/{workflowId}/name", {
        params: { path: { workflowId } },
        body: { name },
      });

      if (response?.error) {
        const error = getErrorMessage(response.error, "Failed to update workflow name");
        throw new Error(error);
      }
      if (response?.response?.status < 200 || response?.response?.status > 299) {
        throw new Error("Unexpected response status: " + response.response.status);
      }

      return response.data;
    },
    onSuccess: () => {
      showToast("success", "Workflow name updated successfully");
      queryClient.invalidateQueries({
        queryKey: configurationApi.queryOptions("get", "/api/Workflow").queryKey,
      });
    },
    onError: (error: Error) => {
      showToast("error", error.message, "Failed to update workflow name");
    },
  });
};
